import {
    AGENT_AVATAR_BLUR_STD_DEVIATION,
    agentAvatarSpec
} from '@/lib/agentAvatar';
import { cn } from '@/lib/utils';
import { useId } from 'react';

interface AgentAvatarProps {
    agentId: string;
    className?: string;
    animate?: boolean;
}

export function AgentAvatar({
    agentId,
    className,
    animate = false
}: AgentAvatarProps) {
    const { blobs } = agentAvatarSpec(agentId);
    // SVG filter/clip ids are global to the document — useId keeps two
    // instances for the same agent (e.g. a dropdown row and its hover card)
    // from colliding.
    const reactId = useId();
    const filterId = `agent-avatar-blur-${reactId}`;
    const clipId = `agent-avatar-clip-${reactId}`;

    return (
        <svg
            viewBox="0 0 100 100"
            className={cn(
                'border border-border rounded-full shrink-0',
                className
            )}
            aria-hidden="true"
        >
            <defs>
                <filter
                    id={filterId}
                    x="-50%"
                    y="-50%"
                    width="200%"
                    height="200%"
                >
                    <feGaussianBlur
                        stdDeviation={AGENT_AVATAR_BLUR_STD_DEVIATION}
                    />
                </filter>
                <clipPath id={clipId}>
                    <circle cx="50" cy="50" r="50" />
                </clipPath>
            </defs>
            <g clipPath={`url(#${clipId})`}>
                <rect width="100" height="100" fill="white" />
                <g filter={`url(#${filterId})`}>
                    {blobs.map((blob, i) => (
                        <circle
                            key={i}
                            className={
                                animate ? 'agent-avatar-blob' : undefined
                            }
                            cx={blob.cx}
                            cy={blob.cy}
                            r={blob.r}
                            fill={blob.color}
                        />
                    ))}
                </g>

                <rect
                    width="100"
                    height="100"
                    fill="black"
                    fillOpacity={0.05}
                />
            </g>
        </svg>
    );
}
